import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5bf911d0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "sub-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-title"
}, "如何使用短信推送", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-des"
}, "PC端打开项目管理后台，在「项目更新」>「历史更新」选择要短信推广的更新，点击短信推广并选择推广人群后，优先使用你账户剩余额度。短信的内容采用固定模版，若账户额度不足时还需额外支付。", -1));
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看视频教学", -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  class: "pc-guide-item"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-title"
}, "查看账户剩余短信条数", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-des"
}, "在项目管理后台下的「运营管理」>「推广记录」可查看账户剩余额度。", -1));
const _hoisted_11 = {
  class: "pc-guide-item"
};
import { onMounted } from "vue";
import domain from "@/service/domain";
import router from '@/router';
export default {
  setup(__props) {
    onMounted(() => {
      document.title = "教程";
    });
    function smsVideoGuideAction() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/promotion/sms_video_guide?video_url=https://p6.moimg.net/mdwxapp/sms_send_guid.mp4`,
        webFun: () => {
          router.push({
            path: `/score/promotion/sms_video_guide`,
            query: {
              'video_url': 'https://p6.moimg.net/mdwxapp/sms_send_guid.mp4'
            }
          });
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", {
        class: "sub-link",
        onClick: _withModifiers(smsVideoGuideAction, ["stop"])
      }, _hoisted_7, 8, _hoisted_5), _createElementVNode("div", _hoisted_8, [_createVNode(_component_van_image, {
        class: "pc-guide-cover",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/promotion_sms_demo_01.png', 690)
      }, null, 8, ["src"]), _createVNode(_component_van_image, {
        class: "pc-guide-cover",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/promotion_sms_demo_02.png', 690)
      }, null, 8, ["src"])]), _hoisted_9, _hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_image, {
        class: "pc-guide-cover",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/promotion_sms_demo_03.png', 690)
      }, null, 8, ["src"])])])]);
    };
  }
};